import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const Icon3dPackage2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="3d-package-2, box, delivery"><path d="M12.0018 1.75L20.8785 6.875V17.125L12.0018 22.25L3.125 17.125V6.875L12.0018 1.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.8785 6.875L12.0018 12M12.0018 22.25V12M3.125 6.875L12.0018 12" stroke="currentColor" strokeWidth="1.5"/><path d="M17.1895 9.00488V14.0039L15.6895 14.8701V9.87012L7.1875 4.96191L7.9375 3.66309L17.1895 9.00488Z" fill="currentColor"/></CentralIconBase>;
};

export default Icon3dPackage2;
